import { render } from "./profitloss1.vue?vue&type=template&id=9a0429e4"
import script from "./profitloss1.vue?vue&type=script&lang=js"
export * from "./profitloss1.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__